import { useEffect, useState } from 'react';

/**
 * Subscribes to a CSS media query. Used where a layout decision cannot be made
 * in CSS alone, such as the number of axis ticks a chart draws.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia(query).matches
      : false,
  );

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mq = window.matchMedia(query);
    const onChange = () => setMatches(mq.matches);
    onChange();
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}

/** Phone-sized viewport: the breakpoint tables collapse into cards at. */
export const NARROW_QUERY = '(max-width: 720px)';

export function useIsNarrow(): boolean {
  return useMediaQuery(NARROW_QUERY);
}
